import { patientApi } from '@/core/api/patient'

export const {
  useCreatePatientMutation,
  useGetPatientQuery,
  useUpdatePatientMutation,
  useListPatientsQuery,
  useLazyGetPatientQuery,
  useLazyGetPatientConsultationsQuery,
  useGetPatientFilesQuery,
  useMergePatientsMutation,
  useGetOrCreateOrdoclicPatientQuery,
  useLazyGetOrCreateOrdoclicPatientQuery,
  useGetOrCreateDesmosPatientQuery,
  useLazyGetOrCreateDesmosPatientQuery,
  useSearchPatientsQuery,
  useLazySearchUnassignedPatientsQuery,
  useGetPatientConsultationsQuery,
  useAttachPatientToEstablishmentMutation,
} = patientApi
